import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalAppAddress } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteAddress, getAddress } from '../../network/Address';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';

const Address = ({ t }) => {
  const client = useQueryClient();
  const [openModal, setOpenModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [idEdit, setIdEdit] = useState(null);
  const [edit, setEdit] = useState(false);
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getAddress],
    queryFn: () => getAddress(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteAddress(id),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getAddress],
      });
    },
    onError: () => {
      message.error('Something went wrong!');
    },
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.address,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setIdEdit(record?.name);
        setOpenModal(true);
        setEdit(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletetheAddress}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.address}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    // {
    //   title: t.Name,
    //   dataIndex: 'name',
    // filteredValue: [searchText],
    // onFilter: (value, record) => {
    //   const name = String(record.name).toLowerCase();
    //   const searchValue = value.toLowerCase();
    //   // console.log(record);
    //   return name.includes(searchValue);
    // },
    // },
    {
      title: t.address_title,
      dataIndex: 'address_title',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.address_title).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.custom_area,
      dataIndex: 'custom_area',
    },
    {
      title: t.city,
      dataIndex: 'city',
    },
    {
      title: t.disabled,
      dataIndex: 'disabled',
      render: (text, record) => {
        return text ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>;
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setIdEdit(record?.name);
                setOpenModal(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheAddress}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  useEffect(() => {
    if (searchParams.get('open') === 'true') {
      setOpenModal(true);
    }
  }, [searchParams]);
  return (
    <div className="payment-entry">
      {/* <Heading title={t.dashboard} subTitle={t.address} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          Placeholder={t.Search + ' ' + t.address}
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpenModal(true);
                setEdit(false);
              }}
            >
              <PlusOutlined size={10} /> {t.addAddress}
            </Button>
          }
        />
      </div>
      <ModalAppAddress
        open={openModal}
        setEdit={setEdit}
        setIdEdit={setIdEdit}
        setOpen={setOpenModal}
        editId={idEdit}
        edit={edit}
        t={t}
      />
    </div>
  );
};

export default Address;
